import React, { use, useEffect, useState } from 'react'
import img1 from "./eesouq.png"
import img2 from "./apple1.png"
import img3 from "./playstore1.png"
import api from '../../api.js'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebook, faLinkedin, faYoutube, faInstagram } from '@fortawesome/free-brands-svg-icons'
import { RiTiktokFill } from "react-icons/ri";
// import { useNavigate } from 'react-router-dom'
const Footer = () => {
  const [category, setCategory] = useState([]);
  const [isMobile,setIsMobile]=useState(window.innerWidth <= 730)

  const handleRedirectplaystore = () => {
    window.open('https://play.google.com/store/apps/details?id=com.eesouqsiance', '_blank');
  };
  const handleRedirectios = () => {
    window.open('https://apps.apple.com/in/app/eesouq/id6745402120', '_blank');
  };

  useEffect(() =>{
    fetchCategories();
  }, []);

  useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 730);
  };

  window.addEventListener("resize", handleResize);
  
  // Clean up
  return () => {
    window.removeEventListener("resize", handleResize);
  };
}, []);

  const fetchCategories = async () => {
    const res = await api.get("/user_api/category/get-category-list");
    setCategory(res.data.category_list);
  };
  return (
    <>
    {!isMobile ?<footer className="footer " role="contentinfo"  >
      <section className="footer-center ">
        <div className="container">
          <div className="row">
            <article
              className="col-xl-3 col-lg-4 col-sm-12 footer-infor collapsed-block "
              data-section-type="storeInfo"
            >
              <div className="footer-logo" style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                {/* <a
                  href="/"
                  className="header-logo__link"
                  data-header-logo-link
                > */}
                  <div className="header-logo-image-container">
                   
                    <a href="/" className="fw-bold fs-3 text-align-center">
                      <img src={img1} alt="Site Logo" width="200px" height="100px" />
                    </a>
                  </div>
                {/* </a> */}
              </div>
              <div className="footer-info-list" style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                
                <div>
                  To get better experience, please Install our App.
                </div>

              </div>
              <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", gap: "10px", margin: "10px" }}>
                <div style={{ width: "100px", height: "100px" }}><img src={img3} onClick={handleRedirectplaystore} /></div>
                <div style={{ width: "100px", height: "100px" }}><img src={img2} onClick={handleRedirectios} /></div>
              </div>
            </article>

            <article
              className="col collapsed-block "
              data-section-type="footer-webPages"
            >
              <h3 className="footer-info-heading">
                Information
                <div className="expander">
                  <i className="icon icon--angle-updown" aria-hidden="true">
                    <svg className="angle-up">
                      <use xlinkHref="#icon-angle-up" />
                    </svg>
                    <svg className="angle-down">
                      <use xlinkHref="#icon-angle-down" />
                    </svg>
                  </i>
                </div>
              </h3>
              <ul className="footer-info-list" style={{paddingLeft: "0px"}}>
                <li>
                  <Link to="/about">About Us</Link>
                </li>
                <li>
                  <Link to="/privacy-policy">Policy & Privacy</Link>
                </li>
                <li>
                  <Link to="/terms-and-conditions">Terms and Condition</Link>
                </li>
                <li>
                  <Link to="/return-policy">Return Policy</Link>
                </li>
                <li>
                  <Link to="/contact-us">Contact Us</Link>
                </li>

              </ul>
            </article>
            <article
              className="col collapsed-block "
              data-section-type="footer-brands"
            >
              <h3 className="footer-info-heading">
                Categories
                <div className="expander">
                  <i className="icon icon--angle-updown" aria-hidden="true">
                    <svg className="angle-up">
                      <use xlinkHref="#icon-angle-up" />
                    </svg>
                    <svg className="angle-down">
                      <use xlinkHref="#icon-angle-down" />
                    </svg>
                  </i>
                </div>
              </h3>
              <ul className="footer-info-list" style={{paddingLeft: "0px"}}>

                {category.filter(item=>item.category_name!=='Lifestyle').map((item, index) => (
                  <li key={index}>
                    <Link to={`/category/${item.slug}`}>{item.category_name}</Link>
                  </li>
                ))}
              </ul>
            </article>
            <article
              className="col collapsed-block"
              data-section-type="footer-categories"
            >
              <h3 className="footer-info-heading">
                Connect with Us
                <div className="expander">
                  <i className="icon icon--angle-updown" aria-hidden="true">
                    <svg className="angle-up">
                      <use xlinkHref="#icon-angle-up" />
                    </svg>
                    <svg className="angle-down">
                      <use xlinkHref="#icon-angle-down" />
                    </svg>
                  </i>
                </div>
              </h3>
              <ul className="footer-info-list" style={{paddingLeft: "0px"}}>
                <li>
                  <a
                    href="#"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                      <FontAwesomeIcon icon={faFacebook} />
                      <span>Facebook</span>
                    </span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/akram_citychoice/?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw%3D%3D#"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                      <FontAwesomeIcon icon={faInstagram} />
                      <span>Instagram</span>
                    </span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/channel/UCwbOehS8lExh_D6S-kmlwyw"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                      <FontAwesomeIcon icon={faYoutube} />
                      <span>Youtube</span>
                    </span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.tiktok.com/@akramcitychoice?_t=8lRDlw1vc4w&_r=1TikTok - Make Your Day"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                     <RiTiktokFill />
                      <span>Tiktok</span>
                    </span>
                  </a>
                </li>
              </ul>
            </article>

            
          </div>
        </div>
      </section>
      <section className="footer-bottom">
        <div className="container">
          <div className="row align-items-center">
            <div className="footer-copyright col-lg-8">
              <span className="powered-by">© 2025 Eesouq</span>
            </div>
            <div className="footer-payment col-lg-4 text-right">
              <div className="footer-payment-icons">
                <svg className="footer-payment-icon">
                  <use href="#icon-logo-american-express" />
                </svg>
                <svg className="footer-payment-icon">
                  <use href="#icon-logo-discover" />
                </svg>
                <svg className="footer-payment-icon">
                  <use href="#icon-logo-mastercard" />
                </svg>
                <svg className="footer-payment-icon">
                  <use href="#icon-logo-paypal" />
                </svg>
                <svg className="footer-payment-icon">
                  <use href="#icon-logo-visa" />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="scrollToTop"></section>
    </footer>
    :
     <footer className="footer " role="contentinfo" >
      <section className="footer-center ">
        <div className="container">
          <div className="row">
            <article
              
            >
              <div className="footer-logo"
               style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <a
                  href="/"
                  className="header-logo__link"
                  data-header-logo-link
                >
                  
                    {/* <img
                        className="header-logo-image"
                        src="../cdn11.bigcommerce.com/s-u4afijuy7q/images/stencil/195x26/logo_1553585953__67107.original.png"
                        srcSet="https://cdn11.bigcommerce.com/s-u4afijuy7q/images/stencil/250x30/logo_1553585953__67107.original.png"
                        alt="Razor - Electronics Store Bigcommerce Theme"
                        title="Razor - Electronics Store Bigcommerce Theme"
                      /> */}
                    <a href="/" className="fw-bold fs-3 text-align-center"
                    style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}
                    >
                      <img src={img1} alt="Site Logo" width="170px" height="80px" />
                    </a>
                
                </a>
              </div>
              <div className="footer-info-list" style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                
                <div>
                  To get better experience, please Install our App.
                </div>

              </div>
              <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", gap: "20px", margin: "10px" }}>
                <div style={{ width: "100px", height: "100px" }}><img src={img3} onClick={handleRedirectplaystore} /></div>
                <div style={{ width: "100px", height: "100px" }}><img src={img2} onClick={handleRedirectios} /></div>
              </div>
            </article>

            <div style={{display:"flex",alignItems:"start",justifyContent:"space-between"}}>
            <article
              
            >
              <h3 className="footer-info-heading">
                Information
               
              </h3>
              <ul className="footer-info-list" style={{paddingLeft: "0px"}}>
                <li>
                  <Link to="/about">About Us</Link>
                </li>
                <li>
                  <Link to="/privacy-policy">Policy & Privacy</Link>
                </li>
                <li>
                  <Link to="/terms-and-conditions">Terms and Condition</Link>
                </li>
                <li>
                  <Link to="/return-policy">Return Policy</Link>
                </li>
                <li>
                  <Link to="/contact-us">Contact Us</Link>
                </li>

              </ul>
            </article>
            <article
             
            >
              <h3 className="footer-info-heading">
                Categories
                
              </h3>
              <ul className="footer-info-list" style={{paddingLeft: "0px"}}>

                {category.filter(item=>item.category_name!=='Lifestyle').map((item, index) => (
                  <li key={index}>
                    <Link to={`/category/${item.slug}`}>{item.category_name}</Link>
                  </li>
                ))}
              </ul>
            </article>
            <article
              
            >
              <h3 className="footer-info-heading">
                Connect with Us
                
              </h3>
              <ul className="footer-info-list" style={{paddingLeft: "0px"}}>
                <li>
                  <a
                    href="#"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                      <FontAwesomeIcon icon={faFacebook} />
                      <span>Facebook</span>
                    </span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/akram_citychoice/?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw%3D%3D#"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                      <FontAwesomeIcon icon={faInstagram} />
                      <span>Instagram</span>
                    </span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/channel/UCwbOehS8lExh_D6S-kmlwyw"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                      <FontAwesomeIcon icon={faYoutube} />
                      <span>Youtube</span>
                    </span>


                  </a>
                </li>
                <li>
                  <a
                    href="https://www.tiktok.com/@akramcitychoice?_t=8lRDlw1vc4w&_r=1TikTok - Make Your Day"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                     <RiTiktokFill />
                      <span>Tiktok</span>
                    </span>
                  </a>
                </li>
              </ul>
            </article>
            </div>
            
          </div>
        </div>
      </section>
      <section className="footer-bottom">
        <div className="container">
          <div className="row align-items-center">
            <div className="footer-copyright col-lg-8">
              <span className="powered-by">© 2025 Eesouq</span>
            </div>
            <div className="footer-payment col-lg-4 text-right">
              <div className="footer-payment-icons">
                <svg className="footer-payment-icon">
                  <use href="#icon-logo-american-express" />
                </svg>
                <svg className="footer-payment-icon">
                  <use href="#icon-logo-discover" />
                </svg>
                <svg className="footer-payment-icon">
                  <use href="#icon-logo-mastercard" />
                </svg>
                <svg className="footer-payment-icon">
                  <use href="#icon-logo-paypal" />
                </svg>
                <svg className="footer-payment-icon">
                  <use href="#icon-logo-visa" />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="scrollToTop"></section>
    </footer>}
    </>
  )
}

export default Footer
